// Simple Supabase client configuration
import { createClient } from '@supabase/supabase-js';
import { config } from './app';

export const supabase = createClient(
  config.supabase.url,
  config.supabase.anonKey
);
